<template> 
  <a-card class="relative">
    <a-button class="back" @click="backHandle">返回</a-button>
    <Globalnfo :info="detail.info"></Globalnfo>
    <a-tabs v-model:activeKey="detail.activeKey" @change="taskChange" v-if="detail.from !='main'">
      <a-tab-pane :key="item.id" :tab="item.number" v-for="item in detail.subTask">
        <a-card class="mt20" title="基本信息" v-if="detail.from != 'main'">
          <div class="wrap">
            <div class="con">
              <dl>
                <dt>状态：</dt>
                <dd>{{ stateCn(detail.subInfo.state) }}</dd>
              </dl>
              
              <dl class="ml20">
                <dt v-if="detail.info.type == 'tag'">筛选说明：</dt>
                <dt v-else>标注说明：</dt>
                <dd><a :href="detail.info.descriptionLink" target="_blank" download>下载</a></dd>
              </dl>
              <dl class="ml20" v-if="detail.info.type == 'tag'">
                <dt>标签：</dt>
                <dd>{{ detail.info.tags.join(',') }}</dd>
              </dl>

            </div>
          
            <div class="con">
              <dl>
                <dt>数量：</dt>
                <dd>{{detail.subInfo.detailTotal}}</dd>
              </dl>
              <dl class="ml20">
                <dt>标注员：</dt>
                <dd v-if="detail.subInfo.labelerName == '待指派'">({{detail.subInfo.labelerName}})</dd>
                <dd v-else>{{detail.subInfo.labelerName}}</dd>
              </dl>
              <dl class="ml20">
                <dt>质检员：</dt>
                <dd  v-if="detail.subInfo.labelerName == '待指派'">({{detail.subInfo.inspectorName}})</dd>
                <dd v-else>{{detail.subInfo.inspectorName}}</dd>
              </dl>
            </div>

          </div>
        </a-card>

        <div>
          <a-card class="label-wrap mt20" title="筛选数据">
            <div>
              <div class="hd mb20">
                <div>
                  <a-checkbox @click="checkAll" v-model:checked="inspectData.checked">全选</a-checkbox> 
             
                  <a-button class="ml10" @click="addTag(tag)" v-for="(tag,index) in detail.info.tags" :key="index">{{ tag }}</a-button>
                  <span class="ml20 fullview">鼠标双击查看大图</span>
                </div>
                <div style="position: absolute;right: 30px;top: 85px;">
                  <a-button type="primary" @click="backHandle()">筛选完成</a-button>
                </div>
              </div>
              <ul class="label-list">
                <li :class="{choose:item.isChoose}" v-for="(item, index) in labelData.list" :key="item.id" @click="toogleChange(index)"  @dblclick="viewResult(item, index, 'img' + index)" :ref="'img' + index">
                  <figure>
                    <a-image  
                      :preview="false"
                      :src="appConfig.baseImgUrl + item.item.accessSrc"
                      fallback="data:image/png;base64,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"
                    >
                    </a-image>
                    <figcaption class="fig" :class="{error:item.qualityState == 'failure', sucess:item.qualityState == 'success'}">
                      <p class="name">{{item.item.id}}</p>
                    </figcaption>
                  </figure>
                  <a-tag v-if="item.tags?.length > 0" color="#2db7f5" style="position: absolute; right:-10px;top:-10px;border-radius: 5px;">{{item.tags[0] }}</a-tag>
                </li>
              </ul>
              <div class="mt20">
                <a-pagination
                style="float:right;margin-right: 30px;"
                v-model:current="labelData.page.num"
                show-quick-jumper
                :pageSize=labelData.page.size
                :total="labelData.page.total"
                :show-total="total => `共 ${total} 条`"
                @change="getDataItem"
              ></a-pagination>
              </div>
            </div>
          </a-card>
        </div>
      </a-tab-pane>
    </a-tabs>    
  </a-card>

  <div class="reslutModal" v-show="viewData.showMark">
    <div class="close" @click="closeModal">X</div>  
    <div class="m-body flex">
      <div class="tc">
        <div class="img-wrap mb20">
          <img :src="appConfig.baseImgUrl + viewData.curData.item.accessSrc" style="width: 100%;" />
        </div>
        
        <div style="text-align: right;">
          <a-button class="ml10" @click="addTag(tag, index + 1)" v-for="(tag,index)  in detail.info.tags" :key="index">{{ tag }}</a-button>
        </div>

        <div class="btn-wrap mt20 tc">
          <a-button type="primary" @click="prevResult" class="mr20">上一张</a-button>
          <a-button type="primary" @click="nextResult">下一张</a-button>
        </div>
      </div>
    </div>
  </div>



</template>
<script>

import Globalnfo from './Globalnfo'
import {publicConfig} from '@/publicConfig.js'
import {useRoute, useRouter} from 'vue-router'
import {forView,subForView, dataItem, inspect, acceptance, completed, inspectCompleted, subSubmit, subDetail, creatTag} from '@/api/taskRelease'
import {reactive, getCurrentInstance, onMounted, computed} from 'vue'

import { mapState } from 'vuex'
import router from '../../../router'
import { message } from 'ant-design-vue'
import {useStore} from '@/store/index2'
export default {
  components:{
    Globalnfo
  },

  // watch: {
  //   mode(mode) {
  //     this.gMap.setMode(mode);
  //     this.setDrawingStyle(mode);
  //   }
  // },
  computed: {
    ...mapState(['appConfig'])
  },

  setup(){
    const instance = getCurrentInstance()
    console.log(instance)
    const route = useRoute()
    const router = useRouter()
    const westCurrentRole = JSON.parse(localStorage.getItem('westCurrentRole'))
    
    const roleId = westCurrentRole.roleId

    const labelTaskId = route.query.taskId || ''
    
    const detail = reactive({    
      from:'',
      page:route.query.page,
      type:route.query.type,
      info:{
        dataset:{},
        project:{},
        purchaseManager:{}  
      },
      subInfo:{

      },
      subTask:[],
      activeKey:'',
    })


    const inspectData = reactive({
      visible:false,
      state:'',
      checked:computed(()=>{
        return labelData.list.every((item)=>{
          return item.isChoose
        })
      }),
      chooseList:computed(()=>{
        return labelData.list.filter((item)=>{
          return item.isChoose
        })
      })
    })

    function toogleChange(index){
      labelData.list[index].isChoose = !labelData.list[index].isChoose 
    }

    function checkAll(){
      if(inspectData.checked){
        labelData.list.forEach((item)=>{
          item.isChoose = false
        })
      }else{
        labelData.list.forEach((item)=>{
          item.isChoose = true
        })
      }
    }


     // 筛选完成（标注完成）
     async function labelFinished(record){
      let params = {
        labelTaskSubId:record.id,
      }
      const {data:res} = await labelCompleted(params)
      if(res.code == 0){
        message.success(res.msg)
        getTaskList()
      }else{
        message.error(res.msg)
      }
      
    }

     let confirmModal = reactive({
       visible:false,
       loading:false
     })




    
    async function checkAction(state){
      let chooseArr = inspectData.list.filter((item)=>{
        return item.isChoose
      })
      
      let detailIds = chooseArr.list.map((item)=>{
        return item.id
      })

      let params = {
        detailIds,
        opType:'ACCEPTANCE',
        state,
      }
      const {data:res} = await inspect(params)
      if(res.code  == '0'){
        message.success(res.msg)
      }else{
        message.error(res.msg)
      }
      
    }

    detail.from = route.query.from
    detail.subTask = JSON.parse(localStorage.getItem('subTask'))   
    detail.activeKey = route.query.subTaskId



    const labelData = reactive({    
      list:[],
      page:{
        num:1,
        size:10,
        total:0
      }
    })
    

      

    async function getDataItem(){
      let from = route.query.from
      let params = {
        //labelTaskSubId, 
        // acceptanceStates:filterData.status,
        // qualityState:filterData.status,
        pageNum:labelData.page.num,
        pageSize:labelData.page.size,
      }
      if(from == 'main'){
        params.labelTaskId = labelTaskId
      }else{
        params.labelTaskSubId = detail.activeKey      
      }
      
      const {data:res} = await dataItem(params)
      labelData.page.total = res.data.total
      labelData.list = [...res.data.records]
      labelData.list.forEach((item)=>{
        item.isChoose = false
      })
    }


   
    /*  查看结果   */
    let viewData = reactive({
      visible:false,
      index:0,
      curData:{
        // previewPath:'https://test-dev.westwell-research.com/testing/preview/files/wellspring/alphaceph/projects/welltesting-dev/2023022300005/CAL_2023022300005_01/images/00be8d6f276b48829e4608a19662d4eb.jpg',
        // dataName:'',
        id:'',
        item:{},
        label:[],
        labelmeDate:{}
      },
      showMark:false,
      imgInfo:{
        width:0,
        height:0
      }

    }) 

    function prevResult(){
      if(viewData.index>0){
        viewData.index--;

        viewResult(labelData.list[viewData.index],viewData.index, 'img' + viewData.index)
       
      }
    }

    function nextResult(){
      if(viewData.index < labelData.list.length - 1){
        viewData.index++;
        instance.ctx.gMap && instance.ctx.gMap.destroy();
        viewResult(labelData.list[viewData.index],viewData.index, 'img' + viewData.index)
      }
    }


    function getViewUrl(src){
      return src
    }




    // 查看总任务详情
    async function getForView(){
      let params = {
        labelTaskId
      }
      const {data:res} = await forView(params)
      detail.info = {...res.data}
      detail.info.descriptionLink = `${publicConfig.requestUrl}${detail.info.descriptionLink}`
      
    }

    getForView()
    

    async function getSubForView(){
      let params = {
        labelTaskSubId:detail.activeKey
      }
      debugger
      const {data:res} = await subForView(params)
      detail.subInfo = {...res.data}
      
    }

   
    
    function taskChange(activeKey){
      console.log(activeKey)
      detail.page
      labelData.page.num = 1
      getSubForView()
      getDataItem()
    }



    function backHandle(){
      router.back()
    }
    

   //  查看标注详情
   function viewResult(result,index, el){
      let naturalWidth = instance.proxy.$refs[el][0].querySelector('img').naturalWidth
      let naturalHeight = instance.proxy.$refs[el][0].querySelector('img').naturalHeight
      viewData.index = index
      viewData.showMark = true
      viewData.curData.id = result.id
      viewData.curData.item = {...result.item}
      viewData.curData.qualityState = result.qualityState
      viewData.curData.acceptanceState = result.acceptanceState
      viewData.curData.label = result.labelData ? {...result.labelData.label} : {}
      viewData.curData.labelmeDate = JSON.parse(result.labelmeDate)
      viewData.imgInfo.width =  naturalWidth
      viewData.imgInfo.height =  naturalHeight
     
    }

    function closeModal(){
      viewData.showMark = false
    } 

    let filterData = reactive({
      status:'',
    })

    function filterLabel(state){
      labelData.page.num = 1
      if(state){
        filterData.status = state
      }else{
        filterData.status = ''
      }
     
      getDataItem()
    }



    async function addTag(tag, index){
      let detailIds = []
      if(index){
        detailIds = [this.viewData.curData.id]
      }else{
        let arr = labelData.list.filter((item)=>{
          return item.isChoose
        })
        detailIds = arr.map((item)=>{
          return item.id
        })

        if(detailIds.length == 0){
          message.success('请至少选择一条数据')
          return
        }
      }

      
      let data = {
        detailIds,
        tags:[tag]
      }
      let {data:res} = await creatTag(data) 
      if(res.code == 0){
        message.success(res.msg)
        getDataItem()
      }else{
        message.success(res.msg)
      }
    }


    


    let store = useStore()
    function stateCn(value){
      return store.getSubStateName(value)
    }


    onMounted(()=>{
      getDataItem()
      getSubForView()

      // instance.proxy.$nextTick(()=>{
      //   alert(666)
      // })
      //instance.proxy.$forceUpdate()

    })  

    

    return {
      roleId,
      detail,
      labelData,
      getForView,
      getSubForView,
      getDataItem,

      viewData,
      closeModal,

      prevResult,
      nextResult,
      getViewUrl,
      taskChange,
      backHandle,
      viewResult,
      inspectData,
      toogleChange,
      checkAll,
   

      checkAction,
 
   

    
      filterData,
      filterLabel,
      addTag,
      confirmModal,


      stateCn,



      labelFinished
      //previewImg,
    
    }

  },
  mounted(){
   
    //this.initCanvas()
  },
  beforbeforeDestroy(){
    this.gMap.destroy();
  }

}
</script>
<style lang="less" scoped>
  .back{
    position: absolute;
    right: 50px;
    top:50px;
    z-index: 1;
  }
  .wrap{
    .con{
      display: flex;
      margin-right: 200px;
      dl{
        display: flex;
        
      }
    }
  }
  .label-wrap{
      .hd{
        
        justify-content: space-between;
      }
    }
  .label-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    li{
      position: relative;
      width: 280px;
      height: 207px;
      display: inline-block;
      margin: 0 20px 30px 20px;
      border:1px solid #ccc;
      text-align: center;
     
      box-sizing: content-box;
      
      .fig{
        margin-top: 10px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: center;
        line-height: 50px;
        height: 50px;
        background: rgba(0,0,0,0.1);
        .name{
          width:95%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: auto;
        }
       
      }
      .sucess{
        background-color: green;
      
        color: #fff;
      }
      .error{
        background-color: red;
  
        color: #fff;
      }
      .tag{
        display: none;
        position: absolute;
        right: 0;
        top:10px;
      }
    }
    .choose{
      border:1px solid blue
    }
  }

  .label-list:after{
    content: '';
    width: 285px;
  }
  .img-wrap{
    display: flex;
    justify-content:center;
    align-items: center;
    // border:1px solid #ddd;
    box-shadow:0px 0px 3px #ddd;
    width:750px;
    height: 400px;
    // img {
    //   max-width:400px;
    //   max-height: 400px;
    // }
  
  }
  .filename{
      font-weight: bold;
      font-size:16px;
    }

  .result-wrap{
    width:100%;
    .result-wrap-text{
    
      height: 290px;;
      border:1px solid #dcdcdc;
      overflow-y: auto;
      padding: 5px;
    }
  }

  .reslutModal{
    border:1px soid #ccc;
    width: 800px;
    position: fixed;
    height: 600px;
    top:9%;
    left:50%;
    margin-left: -400px;
    background: #fff;
    z-index: 100;
    padding: 30px;
    padding-top: 60px;
    
  }

  .mark{
    width: 100%;
    height: 100%;
    background: #000;
    position: fixed;
    opacity: 0.5;
    top:0;
    left:0;
    z-index: 99;
  }

  .close{
    position:absolute;
    top:10px;
    font-size:25px;
    right:30px; 
    cursor: pointer;
  }

  .filter-wrap{
    span{
      border:1px solid #ccc;
      border-radius: 15px;
      padding: 3px 8px;
      margin-right: 10px;
      cursor: pointer;
    }
    .cur{
      border-color: #0C2366;
    }
  } 
  .fullview{
    background: antiquewhite;
    padding: 5px 10px;
  }
</style>
